import { render, staticRenderFns } from "./MotorBikeRightSeat.vue?vue&type=template&id=c118e662"
import script from "./MotorBikeRightSeat.vue?vue&type=script&lang=js"
export * from "./MotorBikeRightSeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports